// add all constant key used for job bucket
export const JOB_BUCKET_GROUP = {
  // CPP page company job buccket
  CPP_COMPANY_JOBS_BUCKET: 'cppJobsBucket',
  CPP_COMPANY_JOB_TITLE_JOBS_BUCKET: 'cppJobTitleJobsBucket',
  CPP_COMPANY_LOCATION_JOBS_BUCKET: 'cppLocationJobsBucket',

  CPP_FALLBACK_TO_PAID_JOBS: 'CPP_FALLBACK_TO_PAID_JOBS',

  // CPP page company competitios jobs bucket
  CPP_SIMILAR_COMPANY_JOBS_BUCKET: 'cppCompetitorJobsBucket',
  //CPP page company subsidiaries jobs bucket
  CPP_SUBSIDIARIES_COMPANY_JOBS_BUCKET: 'cppSubsidiariesJobsBucket',

  // Company review page job bucket
  COMPANY_REVIEW_JOB_BUCKET: 'companyReviewJobBucket',
  // Company review page competitors job bucket
  COMPANY_REVIEW_SIMILAR_JOB_BUCKET: 'companyReviewCompetitorJobBucket',
  // Job title review page job bucket
  JOB_TITLE_REVIEW_JOB_BUCKET: 'jobTitleReviewJobBucket',

  // Company jobs page bucket
  COMPANY_SIMILAR_JOBS: 'companySimilarJobs',

  // 1) resume job page bucket
  // 2) salary job page bucket
  // 3) trends job page bucket
  RESUME_JOBS_BUCKET: 'resumeJobTitleJobsBucket',

  // Salary Job Recently Added Jobs Bucket
  RECENT_SALARY_JOBS_BUCKET: 'recentSalaryJobTitleJobsBucket',

  // salary job page initial salary job bucket
  INITIAL_SALARY_JOBS_BUCKET: 'initialSalaryJobTitleJobsBucket',

  TITLE_INTERNSHIP_JOB_BUCKET: 'titleInternshipJobBucket',

  // DLP company job bucket
  COMPANY_JOBS_BUCKET: 'dlpCompanyJobsBucket',
  COMPANY_JOBS_BUCKET_PAGE: 'dlpCompanyJobsBucketPage',
  // DLP location job bucket
  LOCATION_JOBS_BUCKET: 'dlpLocationJobsBucket',
  LOCATION_JOBS_BUCKET_PAGE: 'dlpLocationJobsBucketPage',

  MOST_SIMILAR_JOBS: 'mostSimilarJobs',

  PAID_JOBS: 'paidJobs',

  PAID_JOBS_FC_CAREER_SALARY: 'paidJobsFCCareerSalary',

  // BCP pages jobs bucket

  BCP_COMPANY_JOB_BUCKET: 'bccJobsBucket',

  // compnay sitemap category and city page
  BEST_COMPANY_CITY: 'bestCompanySitemapCity',
  BEST_COMPANY_CATEGORY_CITY: 'bestCompanySitemapCategoryCity',

  // BCP state and state + category page
  BEST_COMPANY_STATE: 'bestCompanySitemapState',
  BEST_COMPANY_CATEGORY_STATE: 'bestCompanySitemapCategoryState',

  // my profile jobs
  MY_PROFILE_JOBS: 'myProfileJobs',
  MY_APPLIED_JOBS: 'myAppliedJobs',
  CAREER_JOBS_BUCKET_VERTICAL: 'careerJobsVertical',
  CAREER_CLUSTER_ADJECTIVE_PAGE: 'CAREER_CLUSTER_ADJECTIVE_PAGE',
  COMPANY_CLUSTER_ADJECTIVE_PAGE: 'COMPANY_CLUSTER_ADJECTIVE_PAGE',
  CAREER_REMOTE_VERTICAL: 'careerRemoteVertical',
  MY_SALARY_REPORT_JOBS: 'mySalaryReportJobs',
  // compnay sitemap category and state page
  COMPANY_SITEMAP_CATEGORY_STATE: 'companySitemapCategoryState',

  JOB_SEARCH_REMOTE_VERTICAL: 'jobSearchRemoteVertical',

  JOB_SEARCH_HIGH_SCHOOL_VERTICAL: 'jobSearchHighSchoolVertical',

  JOB_SEARCH_FOREIGN_WORKERS: 'jobSearchForeignWorker',

  JOB_SEARCH_LGBTQ_VERTICAL: 'jobSearchLGBTQVertical',

  JOB_SEARCH_REMOTE_COMPANIES: 'jobSearchRemoteCompanies',

  MAJOR_JOBS_BUCKET: 'jobSearchMajor',
  MAJOR_ENTRY_JOBS_BUCKET: 'jobSearchMajorEntry',

  CAREER_SKILLS_JOBS_BUCKET: 'careerSkills',

  CAREER_DEMOGRAPHICS_JOBS_BUCKET: 'careerDemographicsJobs',
  CAREER_DEMOGRAPHICS_COMPARE_JOBS: 'careerDemographicsCompareJobs',
  CAREER_DEMOGRAPHICS_COMPARE_GENDER_ETHIC_LANGUAGE: 'careerDemographicsCompareGenderEthicLanguage',
  CAREER_DEMOGRAPHICS_COMPARE_GENDER_RATIO: 'compareGenderRatioByJobTitle',
  CAREER_DEMOGRAPHICS_COMPARE_LGBT: 'compareGenderRatioLGBT',
  CAREER_DEMOGRAPHICS_COMPARE_AGE_BREAKDOWN: 'compareAgeBreakdown',
  CAREER_DEMOGRAPHICS_COMPARE_DURATION: 'compareDuration',
  CAREER_COMBO_SALARY_JOBS_BUCKET: 'careerComboSalaryJobs',
  CAREER_JOBS_OUTSIDE_BUCKET: 'careerJobsOutside',
  CAREER_CERTIFICATIONS_JOBS_BUCKET: 'careerCertificationsJobsBucket',
  TITLE_SENIOR_MID_LEVEL_BUCKET: 'titleSeniorMidLevelBucket',
  RECOMMENDED_JOBS_OUTSIDE_BUCKET: 'recommendedJobsOutsideBucket',
  SALARY_HISTORY_CHART: 'salaryHistoryChart',
  CAREER_BEST_STATES_BUCKET: 'careerBestStatesBucket',

  // <cityName>-jobs page
  FULL_TIME_JOBS_IN_CITY: 'fullTimeJobsInCity',
  JOBS_IN_CITY: 'jobsInCity',
  RECENTLY_VIEWED: 'recentlyViewed',
  JOBS_FROM_SEACH_API: 'JOBS_FROM_SEACH_API',
  JOBS_FROM_SEACH_API_2: 'JOBS_FROM_SEACH_API_2',

  STATE_JOBS: 'stateJobs',
  JOBS_IN_CITY_STATE: 'jobsInCityState',
  JOBS_IN_CITY_CLUSTER_ADJECTIVE: 'jobsInCityClusterAdjective',

  // <jobTitle>-<cityName>-jobs page
  ALL_JOBS_IN_CATEGORY: 'allJobsInCategory',

  // <jobTitle>-jobs page
  JOB_TITLE_JOB_BUCKET: 'jobTitleJobBucket',
  DASHBOARD_JOB_RECOMMENDED: 'dashboardJobRecommended',
  ENTRY_LEVEL_JOB_TITLE_JOB_BUCKET: 'entryLevelJobTitleJobBucket',
  RECENT_JOB_TITLE_JOB_BUCKET: 'recentJobTitleJobBucket',

  // <title>-major page
  JOBS_BY_MAJOR: 'jobsByMajor',
  ENTRY_LEVEL_JOBS_BY_MAJOR: 'entryLevelJobsByMajor',
  INTERNSHIP_JOBS_BY_MAJOR: 'internshipsJobsByMajor',
  MOST_POPULAR_JOBS_BY_MAJOR: 'mostPopularJobsByMajor',

  // CMP page
  BEFORE_JOBS_JOB_BUCKET: 'beforeJobsJobBucket',
  AFTER_JOBS_JOB_BUCKET: 'afterJobsJobBucket',

  // CMP WTD Featured Jobs
  WTD_FEATURED_JOBS: 'wtdFeaturedJobs',

  // CPP Salary
  RECENT_COMPANY_JOBS: 'recentCompanyJobs',

  // Answers bucket
  JOBS_BY_TITLE: 'jobsByTitle',
  JOBS_BY_COMPANY: 'jobsByCompany',
  JOBS_BY_LOCATION: 'jobsByLocation',
};

export const SALARY_HISTORY_LINE_CHART = 'Salary History Line Chart';

export const EVENTS = {
  redrawGraph: 'redrawGraph',
  nodeClicked: 'nodeClicked',
  drawSkillGraph: 'drawSkillGraph',
  performSearch: 'performSearch',
  signIn: 'signIn',
  dlpPageView: 'dlpPageView',
  profileField: 'profileField',
  bucketScrolled: 'bucketScrolled',
  deleteAccount: 'deleteAccount',
  jobCardSaveClick: 'jobCardSaveClick',
  jobCardDismissClick: 'jobCardDismissClick',
  dlpSaveJobClick: 'dlpSaveJobClick',
  dlpDismissJobClick: 'dlpDismissJobClick',
  filterClick: 'filterClick',
  viewFullListClick: 'viewFullListClick',
  expertAnswersBoxShowMoreClick: 'expertAnswersBoxShowMoreClick',
  adjustmentFilterClick: 'adjustmentFilterClick',
  carouselNavigationClick: 'carouselNavigationClick',
  rbSubscriptionPurchase: 'rbSubscriptionPurchase',
  checkoutPopupOpen: 'checkoutPopupOpen',
  checkoutPopupClose: 'closeCheckoutPopup',
  subscribeFormBtnClick: 'subscribeFormBtnClick',
};
export const REPORT_SALARY_SURVEY = '201';
export const REPORT_SALARY_SURVEY_FROM_MATCHES = '202';

export const WIDGET_NAMES = {
  BEST_STATES_MAP: 'best-states-map',
  TITLE_SALARY_STATES_MAP: 'salary-heatmap',
  TITLE_SALARY_ONLY_STATES_MAP: 'salary-only-state-heatmap',
  TITLE_LOCATION_STATES_MAP: 'location-heatmap',
  TITLE_DEMAND_STATES_MAP: 'demand-heatmap',
  MAJOR_SALARY_STATES_MAP: 'major-salary-map',
  CAREER_PATHS: 'career-paths',
  CAREER_PATHS_V2: 'career-paths-v2',
  COLLEGE_MAJOR_PATHS: 'college-major-paths',
};

export const RATING_CATEGORIES = {
  COMPANY: {
    OVERALL_RATING: 'companyreview-overall-star',
    SALARY_BENEFITS_RATING: 'companyreview-salary-benefits-star',
    MANAGEMENT_RATING: 'companyreview-management-star',
    ENVIRONMENT_RATING: 'companyreview-environment-star',
    DIVERSITY_RATING: 'companyreview-diversity-star',
    OPPORTUNITIES_RATING: 'companyreview-opportunities-star',
  },
  JOB_TITLE: {
    OVERALL_RATING: 'titlereview-overallrating',
    WORK_LIFE_START_RATING: 'titlereview-work-life-star',
    CAREER_GROWTH_START_RATING: 'titlereview-career-growth-star',
    SALARY_STAR_RATING: 'titlereview-salary-star',
  }
}

export const STRIPE_SUBSCRIPTION_STATUS = {
  ACTIVE: 'active',
  UNPAID: 'unpaid',
  PAST_DUE: 'past_due',
  CANCELED: 'canceled',
  TRIALING: 'trialing',
  INCOMPLETE: 'incomplete',
  INCOMPLETE_EXPIRED: 'incomplete_expired',
  SET_TO_CANCEL: 'set to cancel',
}

/** Note: While changing this constant please don't forget
 * to change the same constant in /conf/constants.js file
 */
export const DLP_VIEW_SOURCE = {
  DEFAULT_PAGE_LOAD: 'defaultPageLoad',
  AFTER_PAID_CLICK: 'afterPaidClick',
  AFTER_UNPAID_CLICK: 'afterUnpaidClick',
  AFTER_FILTER_CHANGE: 'afterFilterChange',
  AFTER_BUCKET_CLICK: 'afterBucketClick',
  AFTER_UNPAID_CHANNEL_CLICK: 'afterUnpaidChannelClick',
  AFTER_SHOW_MORE_BUTTON_CLICK: 'afterShowMoreButtonClick',
};

export const RESUME_SUBSCRIPTION_STATUS = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  NOT_ACTIVE: 'NOT_ACTIVE',
  CANCELLED: 'CANCELLED',
  DEACTIVATED: 'DEACTIVATED',
};

export const PAID_JOBS_CATEGORY = {
  CAREER_CLUSTER: 'careerCluster',
  LOCATION: 'location',
  RECOMMENDED: 'recommended',
  RECOMMENDED_TITLE: 'recommendedTitle',
  COMPANY_CLUSTER: 'companyCluster',
  COMPANY_CATEGORIES: 'companyCategories',
};

export const CLUSTER_HEADER_CATEGORY = {
  CAREER: 'career',
  COMPANY: 'company',
  CAREER_COMBO: 'career-combo',
  MAJOR: 'major',
  REMOTE: 'remote',
  LGBTQ: 'lgbtq',
  FOREIGN_WORKERS: 'foreign-workers',
  HIGH_SCHOOL: 'high-school',
  CAREER_SALARY: 'career-salary',
  CAREER_COMBO_SALARY: 'career-combo-salary',
  COMPANY_SALARY: 'company-salary',
  PROFILE: 'profile',
  JOB_SEARCH: 'job-search',
  CITY: 'city',
  COMPANY_FAQ: 'company-faq',
  TOP_LEVEL: 'top-level',
};

export const CMP_SUBPAGES = {
  SKILLS: 'skills',
  BEST_STATES: 'best-states',
  SALARY: 'salary',
  RESUME: 'resume',
  JOBS: 'jobs',
  DYNAMIC: 'dynamic',
  WHAT_THEY_DO: 'what-they-do',
  HOW_TO_BECOME: 'how-to-become',
  REMOTE_JOBS: 'remote-jobs',
  TRENDS: 'trends',
  OVERVIEW: 'overview',
  REVIEWS: 'reviews',
  EDUCATION: 'education',
  DEMOGRAPHICS: 'demographics',
  CERTIFICATIONS: 'certifications',
  DESCRIPTION: 'job-description',
  FAQ: 'faqs',
  HOW_TO_HIRE: 'how-to-hire',
  CAREER_PATH: 'career-path',
  SITEMAP_LOCATION: 'sitemap-location-level',
};

export const EMPLOYER_JOB_POSTING_PAGES = {
  ACCOUNT: '/employer/job-posting/account/',
  JOB_DETAILS: '/employer/job-posting/job-details/',
  JOB_REVIEW: '/employer/job-posting/review/',
  PRICING: '/employer/job-posting/pricing/',
  DASHBOARD: '/employer/job-posting/dashboard/',
  CANDIDATES: '/employer/job-posting/candidates/',
};

export const MAJOR_SUBPAGES = {
  SALARY: 'salary',
  BEST_COLLEGES: 'best-colleges',
};

export const MODERATION_STATUS_LIST = {
  approved: 'APPROVED',
  deferred: 'DEFERRED',
  rejected: 'REJECTED',
  pending: 'PENDING',
};
export const CPP_SUBPAGES = {
  OVERVIEW: 'overview',
  JOBS: 'jobs',
  SALARY: 'salary',
  HISTORY: 'history',
  REVIEWS: 'reviews',
  LOCATIONS: 'locations',
  EXECUTIVES: 'executives',
  REVENUE: 'revenue',
  DEMOGRAPHICS: 'demographics',
  COMPETITORS: 'competitors',
  JOB_TITLE_COMBO_JOBS: 'job-title-combo-jobs',
  LOCATION_COMBO_JOBS: 'location-combo-jobs',
  JOB_TITLE_SALARY: 'job-title-salary',
  FAQ: 'faqs',
  CITY_SALARY: 'city-salary',
  STATE_SALARY: 'state-salary',
  MISSION_STATEMENT: 'mission-statement',
  ALL_JOBS: 'all-jobs',
  JOBS_LOCATIONS: 'jobs-locations',
};

export const TOP_LEVEL_SUBPAGES = {
  JOB: 'Jobs',
  ADJECTIVE_PAGE: 'top-level-adjective-page',
};

export const POPUP_ENTRY_POINT = {
  SHOW_MORE_POPUP: 'Show More Popup',
  SCROLL_BUCKET_POPUP: 'Scroll Bucket Popup',
};

export const POPUP_SURVEY_SOURCE = {
  POPUP_BUCKET_SCROLL: 'popup-bucket-scroll',
  POPUP_SHOW_MORE: 'popup-show-more',
  POPUP_SESSION_DURATION: 'popup-session-duration',
  POPUP_SAVE: 'popup-save',
  POPUP_DISMISS: 'popup-dismiss',
  MAJOR: 'major',
  MATCHES_PAGE: 'matches-page',
  MATCHES_SALARY_PAGE: 'matches-salary-page',
  CMP_PAGE: 'cmp-page',
  CMP_OVERVIEW_PAGE: 'cmp-overview',
  MAJOR_PAGE: 'major-page',
  CAREER_SALARY_PAGE: 'career-salary-page',
  CMP_SALARY_PAGE: 'jobtitle-salary-overview',
  CPP_SALARY_PAGE: 'company-salary-overview',
  CPP_LOCATION_HEADQUARTERS_AND_OFFICES: 'company-location-headquarters-and-offices',
  CPP_LOCATION_HEADER: 'company-location-header',
  CPP_HISTORY_SUMMMARY_BOX: 'company-history-summary-box',
  CPP_HISTORY_ABOUT_LINK: 'company-history-about-link',
  CPP_HISTORY_ABOUT_CARD: 'company-history-about-card',
  CPP_HISTORY_SIMILAR_BOX: 'company-history-similar-box',
  SURVEY_ONE_TAP: 'survey-core-prompt',
  COMPANY_FOLLOW: 'company-follow',
  POST_APPLY_UX_END: 'post-apply-ux-end',
  REMOTE_JOBS_PAGE: 'remote-jobs-page',
  CMP_SALARY_NUM_CALLOUT: 'salarynum-callout',
  BEST_STATES_ANIMATION: 'best-states-animation',
  STICKY_FOOTER_RESUMES: "sticky-footer-resumes",
};

export const SIGN_UP_ERRORS = {
  emailAlreadyTaken: 'Email address already taken!',
  invalidEmail: 'Please enter a valid email',
};

export const RECAPTCHA_SITE_KEY = '6LdVkakZAAAAAOhLW02JeSA0jzM_bWgEWBXQdEBh';

export const BCP_NON_CACHED_CATEGORIES = [
  {
    name: 'Most Diverse',
    apiField: 'unifiedWorkEnvironment',
  },
  {
    name: 'Best Paying',
    apiField: 'unifiedSalary',
  },
];

export const USER_JOB_SITUATION = {
  USER_SPECIFIED: { source: 'user-specified', confidence: 10 },
  DATA_ANALYSIS: { source: 'data-analysis', confidence: 9 },
  BEHAVIOR_ANALYSIS: { source: 'behavior-analysis', confidence: 8 },
};

export const HASH_SUFFIX = '-ish';

export const PUSH_ACTIVITY_TYPES = {
  PUSH_SUBSCRIBED: 'PUSH_SUBSCRIBED',
  PUSH_UNSUBSCRIBED: 'PUSH_UNSUBSCRIBED',
};

export const SIGN_UP_PROMPT_TYPE = {
  POP_UP_SESSION_DURATION: 'popup-session-duration',
  POP_UP_PARTIAL_GATE: 'popup-partialGate',
};

export const USER_ACTIVITY_EVENTS = {
  HTTP: {
    HTTP_ACTIVITY: 'HTTP_ACTIVITY',
  },
  POST_JOB: {
    POST_A_JOB: 'POST_A_JOB',
    POST_A_JOB_SUBSCRIPTION: 'POST_A_JOB_SUBSCRIPTION',
  },
  SURVEY: {
    SAVE_SEARCH: 'SAVE_SEARCH',
    SURVEY_ACTIVITY: 'SURVEY_ACTIVITY',
    AUTOCOMPLETE_SEARCH: 'AUTOCOMPLETE_SEARCH',
  },
  SIGN_UP: {
    SIGN_UP_POPUP: 'SIGN_UP_POPUP',
    EMAIL_ACTIVITY: 'EMAIL_ACTIVITY',
    SIGN_UP_ACTIVITY: 'SIGN_UP_ACTIVITY',
  },
  JOB_OPENING: {
    JOB_OPENING_VIEWED: 'JOB_OPENING_VIEWED',
    JOB_OPENING_SAVED_DLP: 'JOB_OPENING_SAVED_DLP',
    JOB_OPENING_SAVED_CARD: 'JOB_OPENING_SAVED_CARD',
    JOB_OPENING_VIEWED_DLP: 'JOB_OPENING_VIEWED_DLP',
    JOB_OPENING_APPLIED_DLP: 'JOB_OPENING_APPLIED_DLP',
    JOB_OPENING_APPLY_CLICK_DLP: 'JOB_OPENING_APPLY_CLICK_DLP',
    JOB_OPENING_JOB_CLICKED: 'JOB_OPENING_JOB_CLICKED',
    JOB_OPENING_DISMISSED_DLP: 'JOB_OPENING_DISMISSED_DLP',
    JOB_OPENING_DISMISSED_CARD: 'JOB_OPENING_DISMISSED_CARD',
    JOB_OPENING_JOB_CLICKED_DLP: 'JOB_OPENING_JOB_CLICKED_DLP',
  },
  PUSH_NOTIFICATION: {
    PUSH_ACTIVITY: 'PUSH_ACTIVITY',
    BROWSER_NOTIFICATIONS_ACTION: 'BROWSER_NOTIFICATIONS_ACTION',
    BROWSER_NOTIFICATIONS_PROMPT: 'BROWSER_NOTIFICATIONS_PROMPT',
  },
  PROFILE: {
    PROFILE_UPDATE: 'PROFILE_UPDATE',
    PROFILE_NOTIFICATION_UPDATE: 'PROFILE_NOTIFICATION_UPDATE',
  },
  REVIEW: {
    REVIEW_POPUP: 'REVIEW_POPUP',
    REVIEW_SUBMITTED: 'REVIEW_SUBMITTED',
  },
  SP_POP_OUT: {
    SP_POP_OUT_DISPLAYED: 'SP_POP_OUT_DISPLAYED',
    EMPLOYER_POP_OUT_DISPLAYED: 'EMPLOYER_POP_OUT_DISPLAYED',
    SP_POP_OUT_CLICKED: 'SP_POP_OUT_CLICKED',
    EMPLOYER_POP_OUT_CLICKED: 'EMPLOYER_POP_OUT_CLICKED',
    SP_POP_OUT_VIEWED_DLP: 'SP_POP_OUT_VIEWED_DLP',
  },
  SMS_ACTIVITY: {
    SMS_SUBSCRIBED: 'SMS_SUBSCRIBED',
    SMS_UNSUBSCRIBED: 'SMS_UNSUBSCRIBED',
  },
  EMPLOYER: {
    EMPLOYER_JOB_POSTING: 'EMPLOYER_JOB_POSTING',
    EMPLOYER_SUBSCRIPTION: 'EMPLOYER_SUBSCRIPTION',
  },
  CONTENT: {
    CLICK: 'CONTENT_CLICK',
  },
  CHAT_POP_OUT: {
    CHAT_POP_OUT_DISPLAYED: 'CHAT_POP_OUT_DISPLAYED',
  }
};

export const SEARCH_API_QUERY_TYPES = {
  TITLE: {
    FIELD_NAME: 'titleQueryType',
    FIELD_VALUES: {
      ORIGINAL_TITLE_ONLY: 'originalTitleOnly',
      SIMILAR_TITLES_ONLY: 'similarTitlesOnly',
      MIXED: 'mixed',
    },
  },
  COMPANY: {
    FIELD_NAME: 'companyQueryType',
  },
};

export const JOB_POSTING_ACTIVITY_TYPE = {
  CREATED: 'created',
  EDITED: 'edited',
  CLOSED: 'closed',
  DELETED: 'deleted',
}

export const TRACKING = {
  LOG_ACTIVITY: {
    AUTO_COMPLETE: 'AUTO_COMPLETE',
    PROFILE_UPDATE: 'PROFILE_UPDATE',
    COMPANY_REVIEW_SUBMITTED: 'COMPANY_REVIEW_SUBMITTED',
    JOB_UPLOAD_RESUME: 'JOB_UPLOAD_RESUME',
    DLP: 'DLP',
    SP_POP_OUT: 'SP_POP_OUT',
    HEADER_SEARCH: 'HEADER_SEARCH',
    SMS_ACTIVITY: 'SMS_ACTIVITY',
    PUSH_ACTIVITY: 'PUSH_ACTIVITY',
    CHAT_POP_OUT: 'CHAT_POP_OUT',
  },
  SOURCES: new Map(
    Object.entries({
      TMP: { param: 'clickID' },
      RD: { param: 'clickid' },
      AC: { param: 'clickId' },
      RM_JN: { param: 'clickId' },
      RM_A: { param: 'clickId' },
    })
  ),
  PIXEL_SOURCES: new Map(
    Object.entries({
      talroo: { src: 'https://www.jobs2careers.com/conversion2.php?p=5116' },
    })
  ),
};

export const ANSWERS = {
  TYPE: {
    JOB_TITLE: 'JOB_TITLE',
    COMPANY: 'COMPANY',
    MAJOR: 'MAJOR',
    CITY: 'CITY',
    STATE: 'STATE',
    BLOG: 'BLOG',
    EMPLOYER: 'EMPLOYER'
  },
  CATEGORY: {
    JOB_TITLE: 'JOB_TITLE',
    LOCATION: 'LOCATION',
    COMPANY: 'COMPANY',
    JOB_SEARCH: 'JOB_SEARCH',
    HIRING: 'HIRING'
  },
};

export const SIGN_UP_STATUSES = {
  EXIST: 'userAlreadyExists',
  SUCCESS: 'success',
  ERROR: 'error',
};

export const MEDIAN_SALARY_THRESHOLD = 35000;

export const HIDE_GOOGLE_ADS_ROUTES = ['/resume-builder/', '/my-resume/'];
export const GOOGLE_AD_SENSE_PUBLIC_KEY = 'ca-pub-5822163099292706';

export const RESUME_BUILDER_CATEGORY = {
  STEPS: 'Resume Builder',
  LANDING: 'Resume Builder Promo Page',
};

export const CITY_SUBPAGES = {
  JOB: 'city-job-page',
  SALARY: 'city-salary-page',
  PART_TIME_JOBS: 'city-part-time-jobs-page',
};

export const RESUME_TEMPLATES_ORDER = [
  'ColorTheme1',
  'ColorTheme2',
  'ColorTheme5',
  'ColorTheme4',
  'ColorTheme3',
  'TextTheme4',
  'TextTheme7',
  'TextTheme3',
  'TextTheme1',
  'TextTheme6',
  'TextTheme2',
  'TextTheme5',
];

export const RBFormatWidgetType = {
  RANGE: 'range',
  COLOR_PALETTE: 'color_palette',
  DROPDOWN: 'dropdown',
};

export const ZD_JOB_SOURCES = [
  'ZD', 'ZD_DEV', 'ZD_REP'
];

export const RBFormatFields = {
  COLOR: {
    name: 'Color',
    value: 'color',
  },
  TEXT_SIZE: {
    name: 'Text Size',
    value: 'textSize',
  },
  LINE_SPACING: {
    name: 'Line Spacing',
    value: 'lineSpacing',
  },
  SECTION_SPACING: {
    name: 'Section Spacing',
    value: 'sectionSpacing',
  },
};

export const HOURS_IN_YEAR = 2080;

export const MINIMUM_YEAR_FOR_REVENUE = 2009;

export const RESUME = {
  CONTACT_TYPES: {
    EMAIL: 'email',
    PHONE: 'phone',
    LOCATION: 'location',
  },
};

export const JOB_SNIPPET_PRIORITY = {
  TITLE: ['title', 'location', 'company'],
  COMPANY: ['company', 'location', 'title'],
  LOCATION: ['location', 'title', 'company'],
};

// Career How To Become data.articles[i].post_subtype values.
export const HOW_TO_BECOME_STEPS = {
  CERTIFICATION_STEP: 'certification-step',
  DUTIES_STEP: 'duties-step',
  EDUCATION_STEP_MAJORS: 'education-step-majors',
  EDUCATION_STEP: 'education-step',
  EXPERIENCE_STEP: 'experience-step',
  JOB_STEP: 'job-step',
  LICENSE_STEP: 'license-step',
  RESUME_STEP: 'resume-step',
  SKILLS_STEP: 'skills-step',
  TRAINING_STEP: 'training-step',
};

export const CAREER_MAP_CONFIG = {
  DIRECTION_LTR: 'ltr',
  DIRECTION_RTL: 'rtl',
  ICONPOS_LEFT: 'left',
  ICONPOS_RIGHT: 'right',
  ICONPOS_CENTER: 'center',
  ICONTYPE_ARROW: 'arrow',
  ICONTYPE_CIRCLE: 'circle',
};

export const COMPANY_LOGOS_TO_INVERT = ['Eagle Creek'];

export const COMPANY_REVIEW_RATING_CATEGORIES = [
  { key: "RATING", value: "Rating", id: "5b5039afa1a4f037c3641c1a", default: true},
  { key: "SALARY_AND_BENEFITS", value: "Salary and Benefits", id: "637dcd0acea3e4e6e73473a4" },
  { key: "MANAGEMENT", value: "Management", id: "637dce75cea3e4e6e73473a5" },
  { key: "WORK_ENVIRONMENT", value: "Work Environment", id: "637dcebdcea3e4e6e73473a6" },
  { key: "DIVERSITY_AND_INCLUSION", value: "Diversity and Inclusion", id: "637dced8cea3e4e6e73473a7" },
  { key: "CAREER_OPPORTUNITIES", value: "Career Opportunities", id: "637dcef1cea3e4e6e73473a8" }
];

export const COMPANY_REVIEW_QUESTION_IDS = {
  pros: '5b503b1fa1a4f037c3641c1b',
  cons: '5b503b34a1a4f037c3641c1c',
  benefits: '5b503b43a1a4f037c3641c1d',
};

export const JOB_TITLE_REVIEW_RATING_CATEGORIES = [
  { id: '5c2e965d858f55874fb627a6', value: 'Overall Rating', key: "RATING" },
  { id: '63e08d37f1a03b977311f36b', value: 'Work/Life Balance' },
  { id: '63e08d37f1a03b977311f36c', value: 'Career Growth' },
  { id: '63e08d38f1a03b977311f36d', value: 'Pay/Salary' },
];

export const JOB_TITLE_REVIEW_QUESTION_IDS = {
  pros: '5c2e95d7858f55874fb627a1',
  cons: '5c2e95f5858f55874fb627a2',
};

export const REVIEW_CATEGORIES = {
  USER_REVIEWS: 'USER_REVIEWS',
  JOB_TITLE_REVIEWS: 'JOB_TITLE_REVIEWS',
  REDDIT_REVIEWS: 'REDDIT_REVIEWS',
  EMPLOYER_REVIEWS: 'EMPLOYER_REVIEWS',
  EMPLOYER_SUPPLIED_REVIEWS: 'EMPLOYER_SUPPLIED_REVIEWS',
  TITLE_PROFESSOR_ANSWERS: 'TITLE_PROFESSOR_ANSWERS',
};

export const JOB_LEVELS = {
  'Entry Level': 'entry-level',
  'Junior Level': 'junior-level',
  'Mid Level': 'mid-level',
  'Senior Level': 'senior-level',
  'Management': 'management',
  'Executive': 'executive',
  'For Teens': 'forTeens',
}

export const SITEMAP_TITLE_ATTRIBUTES = {
  "MAIN_JOB_TITLE": `What Is {jobTitleArticle} {title}`,
  "JOBS": `{title} Jobs`,
  "RESUME": `{title} Resume`,
  "SALARY": `{title} Salaries`,
  "LOCATIONS": `{title} Jobs By Location`,
  "WHAT_THEY_DO": `{title} - What They Do`,
  "CERTIFICATIONS": `{title} Certifications`,
  "DEMOGRAPHICS": `{title} Demographics`,
  "SKILLS": `{title} Skills`,
  "EDUCATION": `{title} Education`,
}

// Layouts used in newJobSearchUI.
export const JOBCARD_TYPES = {
  STANDARD: 'STANDARD',
  SLIM: 'SLIM',
  SLIM_HORIZONTAL: 'SLIM_HORIZONTAL',
  SLIM_BOX: 'SLIM_BOX',
};

export const HttpRoutes = {
  recentArticles: 'articles/recent',
  autocompleteCompany: 'autocomplete2/company/',
  autocompleteJobTitle: 'autocomplete/source/',
  autocompleteLocation: 'autocomplete/location/',
  autocompleteCollege: 'autocomplete/college/',
  autocompleteMajor: 'autocomplete/major/',
  autocompleteCompanyName: 'autocomplete/company/',
  autocompleteSkills: 'autocomplete/skill/',
  autocompleteCertifications: 'autocomplete/certification/',
  autocompleteLanguage: 'autocomplete/language',
  autocompleteSalaryLocationTitles: 'salaryAutocomplete/locationTitles/',
  autocompleteSalaryLocationCompanies: 'salaryAutocomplete/locationCompanies/',
  autocompleteSalaryTitleLocations: 'salaryAutocomplete/titleLocations/',
  autocompleteSalaryTitleCompanies: 'salaryAutocomplete/titleCompanies/',
  analyticsToLog: 'api/logAnalytic',
  urlParser: '/disambiguate/url?url={url}',
  jobPostings: '/api/jobs/',
  relatedJobPostings: '/api/loadRelatedJobs/',
  jobsBySkill:
    '/api/jobsBySkill?state={state}&city={city}&title={title}&skill={skill}&socCode={socCode}&start={start}&numJobs={numJobs}&locationSort={locationSort}',
  jobTitleSalary:
    '/api/salByLocation?title={title}&city={city}&stateAbbr={stateAbbr}&socCode={soc_code}',
  highSchoolJobs: '/api/highSchoolJobs',
  remoteJobs: '/api/remoteJobs',
  jobTags: '/user/getJobTags?companyId={companyId}&listingHash={listingHash}',
  userProperties: '/user/getuserproperties/',
  companyDetails: '/api/companyDetails/',
  getCompanyDataById: '/api/getCompanyDataById',
  companySalaries: '/api/companySalaries/',
  mostSimilarJobs: '/api/mostSimilarJobs/',
  companySalariesFromId: '/api/companySalariesFromId?companyId={companyId}&socCode={socCode}',
  companySalariesSearch:
    '/api/companySalariesSearch?companyId={companyId}&numSalariesToLoad={numSalariesToLoad}&city={city}&state={state}',
  jobTitleCMP: '/api/cmpSummary?title={title}',
  getPreparedSalaryDataByLocation:
    '/api/getPreparedSalaryDataByLocation?city={city}&stateCode={stateCode}&maxResults={maxResults}&maxRecentDays={maxRecentDays}',
  getSalaryChartDataByTitleAndLocation: '/api/getSalaryChartDataByTitleAndLocation/',
  salaryDataByTitleAndLocation:
    '/api/salaryDataByTitleAndLocation?title={title}&city={city}&stateCode={stateCode}',
  salaryDataByTitleSalaryPagebyLocation: '/api/salaryDataByTitleSalaryPagebyLocation',
  salaryByLocationMajorSalaryPage: '/api/salaryByLocationMajorSalaryPage',
  getSalariesByMajorAndCompany: '/api/getSalariesByMajorAndCompany',
  salaryDataByTitleSalaryPagebyCompany: '/api/salaryDataByTitleSalaryPagebyCompany',
  getSalaryDataByCompany: '/api/getSalaryDataByCompany',
  salaryDataByTitleSalaryPageByJobTitle: '/api/salaryEstimateBatch/',
  getSalaryStatesMapForTitle: '/api/getSalaryStatesMapForTitle?encodedTitle={encodedTitle}',
  getSalaryOnlyStatesMapForTitle:
    '/api/getSalaryOnlyStatesMapForTitle?encodedTitle={encodedTitle}',
  getLocationStatesMapForTitle: '/api/getLocationStatesMapForTitle?encodedTitle={encodedTitle}',
  getDemandStatesMapForTitle: '/api/getDemandStatesMapForTitle?encodedTitle={encodedTitle}',
  getSalaryStatesMapForMajor: '/api/getSalaryStatesMapForMajor?encodedMajor={encodedMajor}',
  fetchCompanySalariesByCompany: '/api/fetchCompanySalariesByCompany/',
  fetchJobTitleRecentSalaries: '/api/getRecentSalariesByTitle',
  careerVideos: '/api/careerVideos?title={title}',
  careerNews: '/api/careerNews?major={major}',
  careerNewsbySlug: '/api/careerNewsbySlug?major={major}&slug={slug}',
  getArticlesBySlug: '/api/getArticlesBySlug?slug={slug}',
  getMajorTitles: '/api/getMajorTitles?major={major}',
  companySalaryCompany:
    '/api/getCompanySalaries?companyId={companyId}&page_no={pageNo}&jobsToLoad={numJobsToLoad}&jobTitle={jobTitle}',
  companyJobs: '/api/getCompanyJobs',
  companySearchSalaries: '/api/searchCompanySalaries',
  getCompanysTopFromParams: '/api/getCompanysTopFromParams?titles={titles}&location={location}',
  getCompaniesDem: '/api/getCompaniesDem?begin={begin}&last={end}',
  getCompaniesRep: '/api/getCompaniesRep?begin={begin}&last={end}',
  getCompaniesTop: '/api/getCompaniesTop?begin={begin}&last={end}',
  getCompanyDisplayMode: '/api/getCompanyDisplayMode?companyId={companyId}',
  getCompanyDonators: '/api/getCompanyDonators?companyId={companyId}&pageNo={pageNo}',
  getFinancialRounds: '/api/getFinancialRounds?companyId={companyId}&pageNo={pageNo}',
  getTopCompanies:
    'api/getTopCompanies?city={city}&state={state}&scoreType={scoreType}&numCompanies={numCompanies}&start={start}&companyType={companyType}&companySize={companySize}&companyCategory={companyCategory}&locationType={locationType}&noIndexCompanies={noIndexCompanies}',
  getTopCompaniesFromCache:
    'api/getTopCompaniesFromCache?city={city}&state={state}&start={start}&companyCategory={companyCategory}',
  setCompanyDisplayMode: '/api/setCompanyDisplayMode',
  getTopCompaniesSalaryEstimatesBySocCode:
    '/api/getTopCompaniesSalaryEstimatesBySocCode?title={title}&city={city}&state={state}&stateName={stateName}&topCount={topCount}',
  getCititesByState: '/api/getCititesByState?state={state}&initialChar={initialChar}',
  fetchJobsByHash: '/api/fetchJobByHash?hash={hash}',
  fetchSurveyById: '/api/fetchsurveybyid?id={id}',
  CMPandCityNews:
    '/api/CMPandCityNews?value1={value1}&valueName1={valueName1}&value2={value2}&valueName2={valueName2}',
  logActivity: '/activity/log/',
  logInWithEmail: '/auth/login/',
  getUserProfile: '/user/getuserprofile/',
  getSalaryReportProfile: `/user/getSalaryReportProfile/`,
  updateUserPreferences: '/user/updatepreferences/',
  updateUserProfile: 'user/profile-update/',
  deactivateAccount: 'user/delete/',
  deactiveStripeAccount: '/user/deactivate-stripe-account/',
  fetchUserFavouriteCompanies: 'user/getUserFavouriteCompanies',
  addSeenJob: 'user/addseenjob/',
  toggleFavorite: 'user/togglefavorite/',
  toggleDismiss: 'user/toggledismiss/',
  toggleSave: 'user/togglesave/',
  toggleApply: 'user/toggleapply/',
  addApplied: 'user/addappliedjob/',
  userMatchesLoad: '/user/loadmatchesjobs/',
  touchBucket: '/user/touchbucket/',
  userSavedDismissedJobs: 'user/userSavedDismissedJobs',
  userListingHashes: 'user/userlistinghashes/',
  userSavedJobs: '/user/saved-jobs/',
  userAppliedJobs: '/user/applied-jobs/',
  userDismissedJob: 'user/userDismissedJob?begin={begin}',
  userSeenJob: 'user/userSeenJob?begin={begin}',
  resetPassword: '/user/send-reset-password-link/',
  resetNewPassword: '/user/reset-password/',
  emailLogin: '/user/authenticate/',
  emailSignUp: '/user/signup/email/',
  employerSignUp: '/user/employer/signup/',
  addHubSpotLeadNote: '/user/employer/add-lead-note/',
  updateLeadDealSize: '/user/employer/update-leaddealsize/',
  companyReview: '/user/companyreview/',
  companyReviewAdmin: '/admin/companyreview/',
  setcompanydisplaymodeUser: 'user/setcompanydisplaymode/',
  getcompanyreviewinfo: 'user/getcompanyreviewinfo/',
  verifyReCaptcha: '/user/verifyrecaptcharesponse/',
  verifySignupReCaptcha: '/user/verifyrecaptcharesponse/signup/',
  uploadImage: '/imageProcessor/normalize',
  surveyResponse: '/user/survey-response/',
  surveyJobs:
    'user/jobsforuser/?surveyId={surveyId}&surveyStartTimeStamp={surveyStartTimeStamp}&major={major}&userId={userId}&page_no={pageNo}',
  bucketsJobs: 'user/jobsforuser/',
  paidJobs: 'user/paidjobs/',
  reviewResponse: 'user/reviewresponse/',
  pageRating: 'user/pageratings/',
  getPageRating: 'user/getpageratings/',
  reviewDetail: '/api/admin/getcompanyreview?reviewId={reviewId}',
  getJobTitleReview: '/api/admin/getJobTitleReview?reviewId={reviewId}',
  getNextPrevReviewForCompany: '/api/getNextPrevReviewForCompany',
  getNextPrevReviewForJobTitle: '/api/getNextPrevReviewForJobTitle',
  getCompanyEmployerReview:
    '/api/getCompanyEmployerReview?companyID={companyID}&includePending={includePending}',
  confirmReview: '/admin/moderatecompany/',
  discardReview: '/admin/discardreview/',
  deferReview: '/admin/deferreview/',
  signUpWithEmail: '/user/signupwithemail/',
  moderateReview: 'api/admin/moderate-review/',
  easyApply: '/user/easy-apply/',
  easyApplyConfirm: '/user/easy-apply-confirm/',
  getEasyApplyUserInfo: '/user/easy-apply/userInfo/',
  fetchCompanyReviewsForAdmin: '/api/admin/getcompanyreviews/',
  fetchJobTitleReviewsForAdmin: '/api/admin/getJobTitleReviews/',
  getCompanyProfileChanges: '/api/admin/getcompanyprofilechanges/',
  majorJobs: '/api/jobsByMajor/',
  activityRecommendationsExtendedJobs: '/api/fetchActivityRecommendationsExtendedJobs/',
  companyTopData: '/api/getCompanyTopData/',
  similarCompanyTopData: '/api/getSimilarCompanyTopData/',
  getCompaniesByIds: '/api/getCompaniesByIds',
  getCompanyInfoByIds: '/api/getCompanyInfoLiteByIds',
  getCompaniesJobsCount: '/api/getCompaniesJobsCount',
  getNormalizedData: '/api/getNormalized/',
  getNormalizedMajorData: '/api/getNormalizedMajor/',
  getProfileSummary: '/api/getProfileSummary?title={title}',
  getRelatedJobTitles: '/api/getRelatedJobTitles?city={city}&state={state}&title={title}',
  employerJob: '/user/employer/job/',
  surveyQuestions: '/api/surveyQuestions?surveyId={surveyId}',
  profileUnsubscribe: '/user/profile-unsubscribe/',
  getSalaryHistoryChartData: '/api/getSalaryHistoryData',
  getEstimateSalaryForSalaryFilter: '/api/getEstimateSalaryForSalaryFilter',
  salaryByJobTitleBatch: '/api/salary-by-jobtitle-batch/',
  getCompaniesAverageSalaries: '/api/fetchCompaniesAvgSalaries',
  getCompetitorJobTitleSalaries: '/api/fetchCompetitorJobTitleSalaries',
  updateUserRating: '/user/update-user-rating/',
  getCompanyReviewsByRating: '/api/fetchCompanyReviewsByRating',
  putReviewFeedback: '/user/put-review-feedback/',
  updateUserBehaviour: '/user/update-user-behaviour/',
  getRemoteCompanies: '/api/getRemoteCompanies',
  updateSalaryReport: '/user/update-salary-report/',
  getActivePushSubscriptions: '/user/active-push-subscriptions/',
  getTopCollegesForTitle: '/api/getTopCollegesForTitle',
  getTopCollegesForMajor: '/api/getTopCollegesForMajor',
  getDiversityPieChartData: '/api/getDiversityPieChartData',
  getGenderRatioBarChartData: '/api/getGenderRatioBarChartData',
  getMostCommonDegreesPieChartData: '/api/getMostCommonDegreesPieChartData',
  getTitleAgeBreakdownData: '/api/getTitleAgeBreakdownData',
  getTitleDurationData: '/api/getTitleDurationData',
  getTitleCompanySizesData: '/api/getTitleCompanySizesData',
  getTitleCompanyTypesData: '/api/getTitleCompanyTypesData',
  getTitleIndustriesData: '/api/getTitleIndustriesData',
  getSalaryByIndustry: '/api/get-salary-by-industry',
  getLgbtRatioData: '/api/getLgbtRatioData',
  updateUserNotifications: '/user/update-notifications/',
  getUserNotifications: '/user/getUserNotifications/',
  getDemographicAdjustmentData: '/api/demographicAdjustmentData',
  getCompanyDemographicAdjustmentData: '/api/companyDemographicAdjustmentData',
  getCompanyEmployeeProfileSummaryForGenders: '/api/getCompanyEmployeeProfileSummaryForGenders',
  getEmployeeProfileSummaryForEthnicities: '/api/getEmployeeProfileSummaryForEthnicities',
  removeUserResume: '/user/remove-resume/',
  getCompanyComparisonData: '/api/getCompanyComparisonData',
  getCollegeExtendedData: '/api/getCollegeExtendedData',
  htmlToDocx: '/api/htmlToDocx',
  resumeBuilderData: '/user/resumeinfo/',
  deleteZohoCandidate: '/user/delete-zoho-candidate/',
  certSuggestions: '/api/certSuggestions',
  randomDescription: '/api/randomDescription',
  skillsSuggestions: '/api/skillsSuggestions',
  certificationsSuggestions: '/api/certificationsSuggestions',
  pushSubscriptionNotification: '/user/push-subscription-notification/',
  adminImportCompany: '/api/admin/import-company',
  generateResumeFile: '/user/generateresumefile/',
  adminAddCompany: '/api/admin/add-company',
  getAverageSalaryByCityAndTitle: '/api/getAverageSalaryByCityAndTitle/',
  getJobCountByLocation: '/api/getJobCountByLocation/',
  deleteResume: '/user/deleteresume/',
  getRBSettings: '/user/get-rb-settings/',
  updateRBSettings: '/user/update-rb-settings/',
  createSquareCustomer: '/user/create-square-customer/',
  createSquareCustomerCard: '/user/create-square-customer-card/',
  createSquareSubscription: '/user/create-square-subscription/',
  cancelSquareSubscription: '/user/cancel-square-subscription/',
  renewSquareSubscription: '/user/renew-square-subscription/',
  fetchPersonalizedMatches: '/user/fetch-personalized-matches/',
  getCompanyDemographicsDataById: '/api/getCompanyDemographicsDataById?companyID={companyID}',
  getJobsFromSearchAPI: '/api/getJobsFromSearchAPI',
  getTitlesIndexes: '/api/getTitlesIndexes',
  downloadResumePdf: '/api/download-resume-pdf/',
  hasSponsoredJobs: '/api/hasSponsoredJobs',
  fetchSponsoredJobs: '/api/fetchSponsoredJobs',
  fetchSearchApiSponsoredJobs: '/api/fetchSearchApiSponsoredJobs/',
  getCompaniesRevenues: '/api/getCompaniesRevenues',
  getTrackingPixels: '/api/getTrackingPixels',
  purchaseStripeSubscription: '/user/purchase-stripe-subscription/',
  addEmployerJobPosting: '/user/add-employer-job-posting/',
  updateEmployerJobPosting: '/user/update-employer-job-posting/',
  fetchEmployerJobPostings: '/user/fetch-employer-job-postings/',
  postADraftJob: '/user/post-a-draft-job/',
  reopenAClosedJob: '/user/reopen-a-closed-job/',
  closeAPostedJob: '/user/close-a-posted-job/',
  deleteAPostedJob: '/user/delete-a-posted-job/',
  fetchJobPostingApplications: '/user/fetch-job-posting-applications/',
  updateApplicationInterest: '/user/update-application-interest/',
  verifyApplication: '/user/verify-application/',
  getSoftSkillsByTitles: '/api/get-soft-skills-by-titles/',
  submitHollandAnswers: '/api/submit-holland-answers/',
  getJobTitlesByInterestCode: '/api/get-jobtitles-by-interestcode/',
  putCareerQuizResults: '/user/put-career-quiz-results/',
  logMessage: '/api/log-message/',
  generateJobDescription: '/api/generate-job-description/',
  generateWorkExperience: '/api/generate-work-experience/',
  generateSummary: '/api/generate-summary/',
};

export const PAGE_CATEGORY = {
  home: 'Home',
  sitemapTopLevel: 'Site Map - Locations',
  sitemapTopLevelCareers: 'Site Map - Careers',
  sitemapTopLevelCollegesMajors: 'Site Map - College and Majors',
  sitemapStateLevel: 'Site Map State',
  sitemapUpAndComing: 'Site Map - Up and Coming Jobs',
  sitemapStateLevelAllCities: 'Sitemap - State Level All Other Cities',
  sitemapIndustryLevel: 'Site Map Industry',
  sitemapCollegeLevel: 'Education Site Map Colleges',
  sitemapDisciplineLevel: 'Education Site Map Majors',
  allMajors: 'Majors Sitemap',
  jobListing: 'Job Listing',
  careerMainPage: 'Career Main Page - Job + City',
  careerMainPageTitleOnly: 'Career Main Page - Job',
  career_skills: 'Career Skills Page',
  careerTrends: 'Career Trends Page',
  careerBestStates: 'Career Best States Page',
  careerSalaryPage: 'Career Salary Page',
  careerJobsPage: 'Career Jobs Page',
  careerWhatTheyDoPage: 'Career What They Do Page',
  careerRemoteJobsPage: 'Career Remote Jobs Page',
  careerDemographicsPage: 'Career Demographics Page',
  careerCertificationsPage: 'Career Certifications Page',
  careerBestStatesWidget: 'Career Best States Widget',
  careerSalaryHeatmapWidget: 'Career Salary Heatmap Widget',
  careerLocationHeatmapWidget: 'Career Location Heatmap Widget',
  careerDemandHeatmapWidget: 'Career Demand Heatmap Widget',
  careerEducationPage: 'Career Education Page',
  careerFaqPage: 'Career FAQs Page',
  careerCareerPathPage: 'Career Path Page',
  majorSalaryHeatmapWidget: 'Major Salary Heatmap Widget',
  major: 'Education Page - Majors',
  college: 'Education Page - College',
  timeline: 'Education Page - DTP',
  signUp: 'Sign Up Flow',
  landing: 'Landing',
  survey: 'Survey Questions',
  matches: 'Matches',
  buckets: 'Buckets',
  dashboard: 'My Dashboard',
  dlp: 'DLP',
  dlpEasyApply: 'DLP - Easy Apply',
  dlpCmp: 'DLP-CMP',
  dlpInterceptor: 'DLP Interceptor',
  profile: 'User Profile',
  companyPage: 'Company Page',
  cityPage: 'City Page',
  companySalaryPage: 'Company Salary Page',
  companyJobsPage: 'Company Jobs Page',
  companyPageReview: 'Single Review - Employee',
  companyCity: 'Sitemap Company - City',
  companyState: 'Sitemap Company - State',
  companyHistoryPage: 'Company History Page',
  companyLocationsPage: 'Company Locations Page',
  companyExecutivesPage: 'Company Executives Page',
  companyRevenuePage: 'Company Revenue Page',
  companyInterviewQuestions: 'Company Interview Questions',
  companyDrugTests: 'Company Drug Tests',
  companyBenefits: 'Company Benefits',
  companyDressCode: 'Company Dress Code',
  companyFaqPage: 'Company FAQ Page',
  companyCompetitorsPage: 'Company Competitors Page',
  companyReviewsPage: 'Company Reviews Page',
  companyMissionStatementPage: 'Company Mission Statement Page',
  cps: 'Company Profile Settings',
  resume: 'Resume Upload Page',
  easyApply: 'Easy Apply Page',
  employerSignup: 'Employer Claim Page',
  employer: 'Post A Job',
  postJobPage: 'Employer Post A Job',
  employerJobPostingSignUp: 'Employer Job Posting - Sign up',
  employerJobPostingPricing: 'Employer Job Posting - Pricing',
  employerJobPostingJobDetails: 'Employer Job Posting - Job Details',
  reviewByUser: 'Single Review - Job Title',
  postJobSubscriptionPage: 'Employer Post A Job Subscription',
  postJobRecruiterPage: 'Employer Hire A New Employee',
  adminReviews: 'Reviews Admins',
  jobTitleReviewsAdmin: 'Job Title Reviews Admin',
  jobSearchForeignWorkersJobs: 'Jobs Search - Foreign Worker Jobs Page',
  jobSearchForeignWorkersHowToFind: 'Jobs Search - Guide to Landing an H1b Job',
  jobSearchForeignWorkersTopCompanies: 'Jobs Search - Top Companies Hiring Foreign Workers',
  jobSearchForeignVisaWorkers: 'Job Search subpage - Foreign Workers Visa',
  highSchoolJobs: 'Job Search - High School Jobs Page',
  highSchoolBestJobs: 'Job Search - Best High School Jobs',
  highSchoolTopCompanies: 'Jobs Search - Top Companies Hiring Teens',
  greenJobs: 'Job Search - Green',
  jobSearchLGBTQJobs: 'Job Search - LGBTQ Jobs Page',
  jobSearchLGBTQJobsHowToFind: 'Job Search - Finding Remote LGBT-Friendly Work',
  adminCompany: 'Companies Admins',
  userSearch: 'User Search',
  reviewJob: 'Job Title Review Survey',
  resumeJobPage: 'Career Resumes Page',
  majorSalaryPage: 'Major Salary Page',
  majorBestCollegesPage: 'Major Best Colleges',
  jobSearchNonprofitJobs: 'Job Search - Nonprofit',
  remoteJobsPage: 'Remote Jobs Page',
  lgbtqScholarships: 'Job Search - LGBTQ Scholarships',
  transJobSeekerGuide: 'Job Search - Trans Worker Guide',
  disabilityJobsPage: 'Job Search - Disability',
  veteransJobsPage: 'Job Search - Veterans',
  salaryReport: 'Salary Report',
  matchesSavedJobs: 'Saved Jobs',
  matchesAppliedJobs: 'Applied Jobs',
  comboSalaryPage: 'City + Job Title Salary',
  comboSalaryPageState: 'State + Job Title Salary',
  greenJobsScholarships: 'Job Search - Green Scholarships',
  profileJobs: 'Job Preferences',
  highSchoolScholarships: 'Job Search - High Schooler Scholarships',
  outdoorJobs: 'Job Search - Outdoors',
  resumeBuilder: 'Resume Builder',
  resumeBuilderLanding: 'Resume Builder Promo Page',
  myResume: 'My Resume',
  manageSubscription: 'Resume Builder - My Subscription',
  paymentHistory: 'Resume Builder - My Payments History',
  answersPage: 'Questions and Answers',
  detailedAnswerPage: 'Answers Pages - DAP',
  citySalaryPage: 'City Salary Page',
  resumeTemplatesPage: 'Resume Builder Promo Page',
  companyDemographics: 'Company Demographics Page',
  sitemapSalaries: 'Site Map - Salaries',
  companyJobTitleJobs: 'Career Main Page - Job + Company',
  companyLocationJobs: 'Career Main Page - City + Company',
  locationIndustry: 'Location Industry Page',
  employerJobPostingReview: 'Employer Job Posting - Job Review',
  employerJobPostingDashboard: 'Employer Job Posting - Dashboard',
  employerJobPostingCandidates: 'Employer Job Posting - Candidates',
  myQuizResults: 'My Quiz Results',
}